import React from "react";

function IconButton(props) {
  return (
    <i
      id={props.id}
      className={`fas fa-${props.icon} IconBtn`}
      onClick={props.onClick}
    />
  );
}

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/IconButton.js